import z from "zod"
import { Errors } from "../../errors"

export const FrontAppIntegrationResponseDataSchema = z
  .object({
    maskedToken: z.string(),
  })
  .nullish()

export const UpsertFrontAppIntegrationResponseDataSchema = z.object({
  maskedToken: z.string(),
})

export const CreateFrontAppTicketConfigSchema = z.object({
  subject: z.string().min(1, { message: Errors.FRONTAPP_SUBJECT_REQUIRED }),
  body: z.string().min(1, { message: Errors.FRONTAPP_BODY_REQUIRED }).default("{{ data.summary }}"),
})

export const TestFrontAppIntegrationResponseDataSchema = z.object({
  data: CreateFrontAppTicketConfigSchema,
  eventPayload: z.record(z.string(), z.any()),
})
